<template>
  <div class="full-screen-select">
    <popup
      ref="popup"
      :full-screen="true"
      :visible="true"
      :title="title"
      :style="popupStyle"
      :show-choose="false"
      @confirm="() => {}"
    >
      <div class="panel-wrap">
        <AddVisitObject
          :options="options"
          :role-id="roleId"
          :contact-id="contactId"
          :is-edit="isEdit"
          @back="back"
          @save="save"
        />
      </div>
    </popup>
  </div>
</template>

<script type="text/ecmascript-6">
// TODO:showChoose 先写死
import Popup from '@/components/Popup'
import { i18n } from '@/common/utils/i18n'
import AddVisitObject from '../AddVisitObject/index.vue'
/* eslint-disable vue/require-default-prop, vue/require-prop-types */
export default {
  name: 'AddVisitObjectPopup',
  components: {
    Popup,
    AddVisitObject
  },
  props: {
    title: {
      required: false,
      type: String,
      default: i18n.gettext('请选择')
    },
    roleId: {
      required: false,
      type: Number
    },
    contactId: {
      required: false,
      type: Number
    },
    isEdit: {
      required: false,
      type: Boolean
    },
    zIndex: {
      required: false,
      type: Number,
      default: 50
    },
    options: {}
  },
  computed: {
    popupStyle() {
      return {
        'z-index': this.zIndex,
      }
    }
  },
  methods: {
    back () {
      this.$refs.popup.hide(() => {
        // 等动画执行500ms后收起，再触发back事件
        setTimeout(() => this.$emit('back'), 500)
      })
    },
    save (data) {
      this.$emit('save', data)
      this.back()
    },
    show () {
      this.$refs.popup.show()
    }
  }
}
</script>

<style lang="scss" scoped>
.full-screen-select {
  overflow: auto;
  &-btn {
    // padding: 10px;
    text-align: left;
    color: $color-light-grey;
    font-size: $fontsize-medium;
  }
  ::v-deep .rich-btn-outline:after {
    border: none;
  }
  .panel-wrap {
    width: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    overflow: auto;
    .checkbox {
      padding: 0 20px;
    }
  }
}
@media only screen and (min-width: 800px) {
  .full-screen-select {
    .popup {
      width: 600px;
      margin: 0 auto;
      left: 0;
      right: 0;
    }
  }
}
</style>
